import { Injectable } from "@angular/core";
import {AngularFireDatabase} from "angularfire2/database";

@Injectable()
export class ProfileService {

  constructor(private db: AngularFireDatabase) { }

  updatePhoneNumber(id, phoneNumber): Promise<void> {
    return this.db.list(`/profile`).update(id, {phoneNumber});
  }
  updateAvatar(id, avatarUrl): Promise<void> {
    return this.db.list(`/profile`).update(id, {avatar: avatarUrl});
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/user/profile.service.ts